import { namespacer } from 'helpers'

const namespace = namespacer('NON_MEMBER_SUBSCRIBE_FORM')

export const SUBSCRIPTION_SUCCESS = namespace('SUBSCRIPTION_SUCCESS')
